/* ============================================================
   CUIDA DE TI — COLLECTION JS (Phase 4)
   Reusable, no external libraries. Provides:
   - CDT.storeRecentlyViewed(item)  — call on PDP to record a view
   - <cdt-recently-viewed>          — renders stored items (localStorage)
   Defer-loaded. Progressive: renders nothing if storage empty/blocked.
   ============================================================ */
(function () {
  'use strict';
  window.CDT = window.CDT || {};
  var KEY = 'cdt_recently_viewed';
  var MAX_STORE = 12;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
  }

  // Called on PDP (Phase 5): item = {url,title,image,price,handle}
  CDT.storeRecentlyViewed = function (item) {
    if (!item || !item.url) return;
    var arr = read().filter(function (x) { return x.url !== item.url; });
    arr.unshift(item);
    if (arr.length > MAX_STORE) arr = arr.slice(0, MAX_STORE);
    write(arr);
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  if (!customElements.get('cdt-recently-viewed')) {
    customElements.define('cdt-recently-viewed', class extends HTMLElement {
      connectedCallback() {
        var grid = this.querySelector('[data-cdt-rv-grid]');
        if (!grid) return;
        var exclude = this.getAttribute('data-exclude') || '';
        var limit = parseInt(this.getAttribute('data-limit'), 10) || 4;
        var items = read().filter(function (x) { return x && x.url && x.handle !== exclude; }).slice(0, limit);
        if (!items.length) return; // stays hidden, no CLS
        var html = '';
        for (var i = 0; i < items.length; i++) {
          var it = items[i];
          var img = it.image ? '<img src="' + esc(it.image) + '" alt="" width="300" height="300" loading="lazy">' : '<span class="cdt-rv__ph"></span>';
          html += '<a class="cdt-rv__card" href="' + esc(it.url) + '">' +
                  '<span class="cdt-rv__media">' + img + '</span>' +
                  '<span class="cdt-rv__title">' + esc(it.title) + '</span>' +
                  (it.price ? '<span class="cdt-rv__price">' + esc(it.price) + '</span>' : '') +
                  '</a>';
        }
        grid.innerHTML = html;
        this.hidden = false;
      }
    });
  }
})();
